import { render, staticRenderFns } from "./DetailsAccount.vue?vue&type=template&id=6ce34878&scoped=true&lang=html&"
import script from "./DetailsAccount.vue?vue&type=script&lang=js&"
export * from "./DetailsAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce34878",
  null
  
)

export default component.exports